import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import translationsService, {
  CSVTranslation,
  Validation,
} from '@/services/translations.service';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TranslationsList',
  setup(__props) {

const file = ref<File | null>(null);
const result = ref<{ faultyLines: Validation[]; updates: CSVTranslation[] }>({
  faultyLines: [],
  updates: [],
});

async function updateTranslations() {
  if (file.value) {
    const response = await translationsService.update(file.value);

    result.value = response.data;

    file.value = null;
  }
}

async function downloadCSV() {
  window.open(
    `${document.location.protocol}//${document.location.host}/api/translation/download`,
    'new',
  );
}

const fileRules = [
  (value: File) => {
    if (value) return true;

    return 'File is required';
  },
  (value: File[]) => {
    if (value && value.length && value[0].type?.indexOf('csv') !== -1) {
      return true;
    }

    return 'File must be of type CSV';
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Translations", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", null, " Download a csv of missing translations or upload a CSV to update translations in the database. ", -1)),
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(updateTranslations, ["prevent"]),
        style: {"max-width":"600px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("p", { class: "ml-10 mt-4" }, "Download missing translations", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    type: "button",
                    color: "success",
                    block: "",
                    class: "mt-2",
                    onClick: downloadCSV
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Download")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: file.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((file).value = $event)),
                    label: "CSV",
                    "filter-by-type": "text/csv",
                    rules: fileRules
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    type: "submit",
                    color: "primary",
                    block: "",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Update")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_alert, {
                    type: "warning",
                    class: "mt-8 mb-8"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Ensure the CSV is correct before updating. And ask Carl to make a database backup before you do this. ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (result.value.updates.length)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "success",
            class: "mt-8 mb-8"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(result.value.updates.length) + " translations have been updated. ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (result.value.faultyLines.length)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            class: "mt-8 mb-8"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(result.value.faultyLines.length) + " translations failed to be updated have been updated. Check rows " + _toDisplayString(result.value.faultyLines.map((l) => l.index).join(', ')) + " and try again. ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})